import React from 'react';
import {
  addressSchema,
  addressUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../utils/content.json';

const updatedAddressSchema = addressSchema({
  omit: ['street3'],
  extend: {
    street: { maxLength: 74 },
    street2: { maxLength: 13 },
    city: { maxLength: 22 },
  },
});

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['mailing-address-title']),
    'ui:description': <p>{content['mailing-address-description']}</p>,
    claimantAddress: addressUI({
      labels: {
        street2: content['mailing-address-street2-label'],
        militaryCheckbox: content['mailing-address-military-label'],
      },
      omit: ['street3'],
    }),
  },
  schema: {
    type: 'object',
    required: ['claimantAddress'],
    properties: {
      claimantAddress: updatedAddressSchema,
    },
  },
};
